import React, {Component} from 'react';
import {Link} from 'react-router';
import Translate from '../layout/Translate';

export default class Feedback extends Component {

  constructor(props) {
    super(props);
    this.state = {
      messageParams: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        text: '',
        title: 'Обратная связь с сайта - ' + this.props.user.lang,
        lang: this.props.user.lang,
        privacy: false
      }
    };
  }

  componentDidUpdate (prevProps) {
    let actions = this.props.actions;

    if (this.props.user.message && this.props.user.message.promise) {
      this.props.user.message.promise.json().then(function (result) {
        actions.setMessageResult(result);
      });
    }

    // Обновляем состояние, если изменились feedbackOptions
    if (prevProps.user.feedbackOptions !== this.props.user.feedbackOptions) {
      const { messageParams } = this.state;
      if (this.props.user.feedbackOptions) {
        if (this.props.user.feedbackOptions.tour) {
          messageParams.title = this.props.user.feedbackOptions.tour.title;
          messageParams.tour = this.props.user.feedbackOptions.tour;
        }
        if (this.props.user.feedbackOptions.departure) {
          messageParams.departure = this.props.user.feedbackOptions.departure;
        }
        this.setState({ messageParams });
      }
    }
  }

  validateEmail (email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validateParams (params) {
    var validationConfig = {
        firstName: 'require',
        lastName: 'require',
        email: 'email'
      },
      validation = [],
      hasErrors = false;

    for (var key in params) {
      switch (validationConfig[key]) {
        case 'require':
          if (!params[key]) {
            validation[key] = true;
            hasErrors = true;
            validation.push({field: key});
          }
          break;
        case 'email':
          if (!params[key] || !this.validateEmail(params[key])) {
            hasErrors = true;
            validation.push({field: key});
          }
          break;
        default:
          break;
      }
    }

    this.props.actions.validateMessage(validation);

    return hasErrors;
  }

  send () {
    const { messageParams } = this.state;

    if (this.props.user.feedbackOptions) {
      if (this.props.user.feedbackOptions.tour) {
        messageParams.title = this.props.user.feedbackOptions.tour.title;
        messageParams.link = this.props.path.user.host + this.props.path.location.pathname;
        messageParams.tour = this.props.user.feedbackOptions.tour;
      }
      if (this.props.user.feedbackOptions.departure) {
        messageParams.departure = this.props.user.feedbackOptions.departure;
      }
    }

    if (!this.props.load && !this.validateParams(messageParams)) {
      this.props.actions.sendMessage(messageParams);
    }
  }

  changeInfo (field, e) {
    this.setState({
      messageParams: {
        ...this.state.messageParams,
        [field]: e.target.value
      }
    });
  }

  changeCheckbox(field, e) {
    this.setState({
      messageParams: {
        ...this.state.messageParams,
        [field]: !this.state.messageParams[field]
      }
    });
  }

  handleKeyPress (e) {
    if (e.key === 'Enter') {
      this.send();
    }
  }

  toggleModal () {
    this.props.actions.toggleFeedback();
  }

  render () {
    let {user} = this.props;

    let success = false;
    if (this.props.user.message && this.props.user.message.success) {
      success = true;
    }

    let errors = {};
    if (this.props.user.message && this.props.user.message.result && this.props.user.message.result.length) {
      this.props.user.message.result.forEach(function (error) {
        errors[error.field] = true;
      });
    }

    return (
      <div className={"popup " + (this.props.open ? 'popup_active' : '')}>
        <div className="popup popup_active">
          <div className="popup__window popup__window_feedback feedback">
            <div className="feedback__title">
              {user.feedbackOptions && user.feedbackOptions.departure &&
                <Translate slug="feedback__order"/>
              }
              {(!user.feedbackOptions || (user.feedbackOptions && !user.feedbackOptions.departure)) &&
                <Translate slug="feedback__title"/>
              }
            </div>
            <div className="popup__close" onClick={this.toggleModal.bind(this)}></div>
            {!success &&
              <div>
                <div className="feedback__row">
                  <input className={"feedback__field " + (errors['firstName'] ? 'feedback__field_error' : '')}
                         onChange={this.changeInfo.bind(this, 'firstName')}
                         onKeyPress={this.handleKeyPress.bind(this)} placeholder={this.props.translations["feedback__first-name"]}/>
                </div>
                <div className="feedback__row">
                  <input className={"feedback__field " + (errors['lastName'] ? 'feedback__field_error' : '')}
                         onChange={this.changeInfo.bind(this, 'lastName')}
                         onKeyPress={this.handleKeyPress.bind(this)} placeholder={this.props.translations["feedback__last-name"]}/>
                </div>
                <div className="feedback__row">
                  <input className={"feedback__field " + (errors['email'] ? 'feedback__field_error' : '')}
                         onChange={this.changeInfo.bind(this, 'email')}
                         onKeyPress={this.handleKeyPress.bind(this)} placeholder={this.props.translations["feedback__email"]}/>
                </div>
                <div className="feedback__row">
                  <input className={"feedback__field " + (errors['phone'] ? 'feedback__field_error' : '')}
                         onChange={this.changeInfo.bind(this, 'phone')}
                         onKeyPress={this.handleKeyPress.bind(this)} placeholder={this.props.translations["feedback__phone"]}/>
                </div>
                <div className="feedback__row">
                  <textarea className={"feedback__textarea " + (errors['text'] ? 'feedback__textarea_error' : '')}
                            onChange={this.changeInfo.bind(this, 'text')}
                            placeholder={this.props.translations["feedback__message"]}></textarea>
                </div>
                <div className="feedback__row">
                  <label className="conditions"><input className="checkbox" type="checkbox"
                                                       checked={this.state.messageParams.privacy}
                                                       onChange={this.changeCheckbox.bind(this, 'privacy')}/>
                    <span><Translate slug="custom__accept2"/> <a
                      href="/privacy" target="_blank"> <Translate slug="custom__privacy"/></a></span></label>
                </div>
                <div className="feedback__row">
                  <input type="submit"
                         className={"feedback__button " + (this.props.load ? 'feedback__button_progress' : '')}
                         value={this.props.translations["feedback__send"]} onClick={this.send.bind(this)}/>
                </div>
              </div>
            }
            {success &&
              <div className="feedback__success"><Translate slug="feedback__complete"/></div>
            }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/popups/Feedback.js